<template>
	<action-sidebar
	:title="title"
	:value="true"
	:width="524"
	@close-modal="closeModal">
		<v-layout px-4 mt-3 row wrap>
			<v-flex xs12 mb-4 v-if="isDealers">
				<v-text-field
					background-color="white"
					box
					class="body-1"
					hide-details
					label="Compañia"
					v-model="model.numDocument"
					:error="!$v.model.numDocument.required"
				></v-text-field>
			</v-flex>
			<v-flex xs12 mb-4 v-if="!isDealers">
				<v-select
					background-color="white"
					box
					class="body-1 mt-2"
					hide-details
					item-text="name"
					item-value="id"
					label="Seleccionar distribuidor"
					:items="dealers"
					v-model="model.distributorId"
					:error="!$v.model.distributorId.required"
				></v-select>
			</v-flex>
			<v-flex xs12 mb-4>
				<v-text-field
					background-color="white"
					box
					class="body-1"
					hide-details
					label="Nombre y Apellido"
					v-model="model.name"
					:error="!$v.model.name.required"
				></v-text-field>
			</v-flex>
			<v-flex xs12 mb-4>
				<v-text-field
					background-color="white"
					box
					class="body-1"
					hide-details
					label="Email"
					v-model="model.email"
					:error="!($v.model.email.required && $v.model.email.email)"
					></v-text-field>
			</v-flex>
			<v-flex xs12 mb-4>
				<v-text-field
					background-color="white"
					box
					class="body-1"
					hide-details
					type="password"
					label="Contraseña"
					v-model="model.password"
					:error="!$v.model.password.required"
					v-if="!id"
				></v-text-field>
			</v-flex>
			<v-flex xs12 mb-4>
				<v-text-field
					background-color="white"
					box
					class="body-1"
					hide-details
					type="number"
					label="Telefono"
					v-model="model.phone"
				></v-text-field>
			</v-flex>
			<v-flex xs12 mb-2>
				<v-select
					background-color="white"
					box
					class="body-1 mt-2"
					hide-details
					item-text="name"
					item-value="id"
					label="País"
					:items="countries"
					v-model="model.countryId"
					:error="!$v.model.countryId.required"
				></v-select>
			</v-flex>
			<v-flex xs12 v-if="!isDealers">
				<v-checkbox
					color="success"
					v-model="model.flagAdmin"
					hide-details
					label="Administrador"
				>
				</v-checkbox>
			</v-flex>
		</v-layout>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				:isLoading="$v.$invalid"
				@accept-button-clicked="createUser"
				@cancel-button-clicked="closeModal"
			></modal-sidebar-button>
		</section>
	</action-sidebar>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import { required, requiredIf, email } from 'vuelidate/lib/validators';

function closeModal() {
	const route = this.$route.name === 'page-dealers-new' ? 'page-config-dealers' : 'page-config-implementers';
	this.goTo(route);
}

function created() {
	this.loadData();
	if (!this.isDealers) {
		this.loadDealers();
	}
}

async function loadData() {
	const url = this.isDealers ? 'distributaries' : 'implementers';
	let response = {};
	let edit = {};
	const requests = [
		this.$http.get('countries'),
	];
	if (this.id) {
		requests.push(this.$http.get(`${url}/${this.id}`));
	}
	try {
		const responses = await Promise.all(requests);
		[{ data: response }] = responses;
		this.countries = response.data;
		if (this.id) {
			[, { data: edit }] = responses;
			this.model.numDocument = edit.data.numDocument;
			this.model.name = edit.data.name;
			this.model.phone = edit.data.phone;
			this.model.countryId = edit.data.countryId;
			this.model.flagAdmin = Boolean(edit.data.flagAdmin);
			this.model.email = edit.data.email;
			this.model.distributorId = edit.data ? edit.data.distributor &&
			edit.data.distributor.data.id : null;
		}
	} catch (error) {
		this.showError();
	}
}

function isDealers() {
	return this.$route.name === 'page-dealers-new';
}

async function loadDealers() {
	const { data: response } = await this.$http.get('distributaries');
	this.dealers = response.data;
}

async function createUser() {
	if (this.$route.name === 'page-dealers-new') {
		delete this.model.distributorId;
		this.model.flagAdmin = true;
	} else {
		delete this.model.numDocument;
	}
	let url = this.$route.name === 'page-dealers-new' ? 'distributaries' : 'implementers';
	const method = this.id ? 'put' : 'post';
	const message = this.id ? 'actualizó' : 'creó';
	if (this.id) {
		url = `${url}/${this.id}`;
	}
	try {
		await this.$http[method](url, this.model);
		this.showNotification(`Se ${message} correctamente'`);
		this.closeModal();
	} catch (error) {
		this.showError();
	}
}

function title() {
	return this.id ? 'Editar Usuario' : 'Crear Usuario';
}

function validations() {
	const validation = {
		model: {
			numDocument: {
				required: requiredIf(() => this.isDealers),
			},
			password: {
				required: requiredIf(() => !this.id),
			},
			name: {
				required,
			},
			email: {
				email,
				required,
			},
			countryId: {
				required,
			},
			distributorId: {
				required: requiredIf(() => !this.isDealers),
			},
		},
	};
	return validation;
}

function data() {
	return {
		typeUsers: [
			{
				id: 1,
				name: 'Distribuidor',
			},
			{
				id: 2,
				name: 'Implementador',
			},
		],
		model: {
			numDocument: null,
			name: null,
			password: null,
			phone: null,
			countryId: null,
			flagAdmin: false,
			distributorId: null,
			email: null,
		},
		countries: [],
		dealers: [],
	};
}

export default {
	name: 'page-config-create',
	components: {
		actionSidebar,
	},
	computed: {
		isDealers,
		title,
	},
	created,
	data,
	methods: {
		closeModal,
		loadData,
		loadDealers,
		createUser,
	},
	props: {
		id: [Number, String],
	},
	validations,
};
</script>




// WEBPACK FOOTER //
// src/pages/configuration/page-config-create.vue